if (!Symbol.asyncIterator) {
  Symbol.asyncIterator = Symbol('asyncIterator');
}

if (!Symbol.testData) {
  Symbol.testData = Symbol('testData');
}
